import * as React from 'react';
import { IconSizes, XCircleIcon } from '@newcore/icons';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { TextSizes } from '@newcore/ui/enums/typography-text-sizes';
import { Text } from '@newcore/ui/typography';
import {
  ONBOARDING_DEFAULT_TITLE,
  OnboardingStatusCard,
} from './onboarding-status-card';

interface OnboardingPageErrorProps {
  title?: string;
  subtitle?: string;
  errorTitle?: string;
  error?: string | null;
  helpText?: string;
}

export function OnboardingPageError({
  title = ONBOARDING_DEFAULT_TITLE,
  subtitle = 'Something went wrong',
  errorTitle = 'Invalid Link',
  error,
  helpText = 'Please contact your administrator for assistance.',
}: OnboardingPageErrorProps): React.ReactElement {
  return (
    <OnboardingStatusCard title={title} description={subtitle}>
      <XCircleIcon size={IconSizes.XL} className='size-16 text-error-primary' />
      <Text
        as='p'
        size={TextSizes.LG}
        weight={FontWeights.MEDIUM}
        className='text-error-primary'
      >
        {errorTitle}
      </Text>
      <Text as='p' className='text-tertiary text-center'>
        {error ??
          'This invitation link is not valid. Please check your email for the correct link or contact your administrator.'}
      </Text>
      <Text as='p' className='text-tertiary text-center'>
        {helpText}
      </Text>
    </OnboardingStatusCard>
  );
}
